import React, { useCallback, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { OpenInFull } from '@mui/icons-material';
import { useBoolean } from 'react-hanger';
import { Translate } from 'c-translation';
import type { FileBrowserFile } from './types';
import FilePreviewDialog from './FilePreviewDialog';

type Props = {
    file: FileBrowserFile;
};

const OpenFilePreviewDialog: React.FC<Props> = ({ file }) => {
    const downloadable = useMemo(() => file?.urls?.download, [file]);
    const { value: isExpanded, setTrue: expand, setFalse: collapse } = useBoolean(false);
    const onClick = useCallback(
        e => {
            e.stopPropagation();
            expand();
        },
        [expand],
    );

    return useMemo(
        () => (
            <>
                {downloadable && (
                    <>
                        <Tooltip title={<Translate path="FileBrowser.filePreview.expand" />}>
                            <IconButton onClick={onClick}>
                                <OpenInFull />
                            </IconButton>
                        </Tooltip>
                        <FilePreviewDialog file={file} open={isExpanded} close={collapse} />
                    </>
                )}
            </>
        ),
        [collapse, downloadable, file, isExpanded, onClick],
    );
};

export default OpenFilePreviewDialog;
